module.exports = __webpack_public_path__ + "img/img3.b5c067ea.jpg";